<template>
  <div>
    <v-dialog v-model="dialogVoucher" max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Voucher</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <center>
              <img style="max-width: 100%" :class="voucherVerClase" :src="mostrarVoucher(voucherVer)" @click="rotar()"/>
            </center>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="cerrarVoucher">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar flat color="white">
      <v-toolbar-title>Pagos</v-toolbar-title>
      <v-divider
        class="mx-2"
        inset
        vertical
      ></v-divider>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="buscar"
        label="Buscar"
        single-line
        hide-details
        @change="actualizar()"
      ></v-text-field>
      <v-btn text icon @click="actualizar()">
        <v-icon>search</v-icon>
      </v-btn>
      <v-dialog v-model="dialog" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Pago</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              Eliminar pago {{ registro.operacion }}
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click.native="eliminarRegistro" v-if="eliminar">Confirmar eliminación</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="datos.data"
      :pagination.sync="pagination"
      :total-items="totalRegistros"
      :loading="loading"
      rows-per-page-text="Filas por página"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.fila[1] }}</td>
        <td class="">{{ props.item.fila[2] }}</td>
        <td class="">{{ props.item.fila[3] }}</td>
        <td class="">{{ props.item.fila[4] }}</td>
        <td class="">{{ props.item.fila[5] }}</td>
        <td class="" v-if="props.item.fila[6] == 1" style="color: red">{{ estados[props.item.fila[6]] }}</td>
        <td class="" v-if="props.item.fila[6] == 2" style="color: green">{{ estados[props.item.fila[6]] }}</td>
        <td class=""><img style="max-width: 100%" :src="mostrarVoucher(props.item.fila[7])" @click="abrirVoucher(props.item.fila[7])"/></td>
        <td align="center">
          <v-tooltip bottom v-if="props.item.fila[6] === '1'">
            <v-icon
              slot="activator"
              @click="verificarRegistro(props.item, 2)"
            >done</v-icon>
            <span>Verificar</span>
          </v-tooltip>
          <v-tooltip bottom v-if="props.item.fila[6] === '2'">
            <v-icon
              slot="activator"
              @click="verificarRegistro(props.item, 1)"
            >clear</v-icon>
            <span>Quitar verificado</span>
          </v-tooltip>
          <v-tooltip bottom v-if="usuarioApp.toUpperCase() === 'ADMINSAN'">
            <v-icon
              slot="activator"
              @click="eliminarRegistro(props.item)"
            >delete</v-icon>
            <span>Eliminar</span>
          </v-tooltip>
        </td>
      </template>
      <template slot="no-data">
        -
      </template>
    </v-data-table>
  </div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  props: ['login', 'tipoUsuario', 'usuarioApp'],
  data: () => ({
    dialog: false,
    dialogVoucher: false,
    disabledRegistro: true,
    eliminar: false,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menu: false,
    cierreFecha: null,
    voucherVer: '',
    voucherVerClase: '',
    buscar: '',
    headers: [
      { text: 'Código', value: 0 },
      { text: 'Tipo', value: 1 },
      { text: 'Nombre', value: 2 },
      { text: 'Número de operación', value: 3 },
      { text: 'Monto', value: 4 },
      { text: 'Estado', value: 5 },
      { text: 'Voucher', align: 'center', value: '', sortable: false },
      { text: 'Verificar', align: 'center', value: '', sortable: false }
    ],
    datos: [],
    registro: {},
    lista: {},
    estados: ['', 'Por verificar', 'Procesado'],
    requeridoRegla: [
      v => !!v || 'Requerido'
      // v => (v && v.length <= 10) || 'Name must be less than 10 characters'
    ],
    emailRegla: [
      v => !!v || 'Correo es requerido',
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Correo debe ser válido'
    ],
    voucherURL: '',
    voucherArchivo: ''
  }),
  computed: {
    computedCierreFecha () {
      return this.formatoFecha(this.registro.cierreFecha)
    }
  },
  watch: {
    dialog (val) {
      val || this.cerrar()
    },
    'registro.cierreFecha' (val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha)
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize()
    if (this.login === false) {
      this.$router.push('/Ingresar')
    }
    this.pagination.rowsPerPage = 10
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaRegistros (idx, ord, pagina) {
      this.loading = true
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina,
        buscar: this.buscar
      }
      solicitudApi.datos = datos
      const myRequest = new Request(`${process.env.API}inicio.php?mod=pagos&accion=listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.datos = datos.d
            this.totalRegistros = this.datos.registros
            if (parseInt(this.datos.pagina) !== parseInt(this.pagination.page)) {
              this.pagination.page = parseInt(this.datos.pagina)
            }
            this.loading = false
          }
        })
    },
    setTotal: function (total) {
      this.registro.comprobanteTotal = total
    },
    verificarRegistro (item, estado) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {id: item.id, valor: estado}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=pagos&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              let descendente = 0
              if (this.pagination.descending) {
                descendente = 1
              }
              this.registro = {}
              this.voucherURL = ''
              this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
            } else {
              alert(datos.m)
            }
          }
        })
    },
    actualizar () {
      let descendente = 0
      if (this.pagination.descending) {
        descendente = 1
      }
      this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
    },
    eliminarRegistro (item, estado) {
      if (!this.eliminar) {
        this.registro.id = item.fila[0]
        this.registro.operacion = item.fila[4]
        this.dialog = true
        this.eliminar = true
        return
      }
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {id: this.registro.id}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=pagos&accion=eliminar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              let descendente = 0
              if (this.pagination.descending) {
                descendente = 1
              }
              this.registro = {}
              this.voucherURL = ''
              this.dialog = false
              this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
            } else {
              alert(datos.m)
            }
          }
        })
    },
    nuevoRegistro () {
      this.verRegistro({fila: [0]})
    },
    abrirVoucher (voucher) {
      this.voucherVerClase = ''
      this.voucherVer = voucher
      this.dialogVoucher = true
    },
    cerrarVoucher (voucher) {
      this.dialogVoucher = false
    },
    cerrar () {
      this.dialog = false
      this.eliminar = false
      setTimeout(() => {
      }, 300)
    },
    registrarPago () {
      var totalPagar = this.lista.total
      for (var item in this.datos.data) {
        totalPagar -= this.datos.data[item].fila[2]
      }
      if (parseFloat(this.registro.monto) !== parseFloat(totalPagar.replace(/,/g, ''))) {
        alert('Monto no corresponde con lo que debe pagar: ' + totalPagar)
        return
      }
      var solicitudApi = this.crearSolicitud()
      if (this.registro.operacion === undefined || this.registro.monto === undefined || this.registro.voucher === undefined || this.registro.operacion === '' || this.registro.monto === '' || this.registro.voucher === '') {
        alert('Debe llenar todos los campos')
      } else if (this.registro.monto === '0.00') {
        alert('Monto no puede ser 0')
      } else {
        solicitudApi.datos = this.registro
        if (this.$route.params.idAlumno !== undefined) {
          solicitudApi.datos.idAlumno = this.$route.params.idAlumno
        }
        const myRequest = new Request(`${process.env.API}inicio.php?mod=pago&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
        return fetch(
          myRequest
        )
          .then(response => response.json())
          .then(datos => {
            if (datos.l === false) {
              this.$emit('login', datos.m)
            } else {
              if (datos.e === 1) {
                let descendente = 0
                if (this.pagination.descending) {
                  descendente = 1
                }
                this.registro = {}
                this.voucherURL = ''
                this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
              } else {
                alert(datos.m)
              }
            }
          })
      }
    },
    subirVoucher () {
      this.$refs.image.click()
    },
    registrarVoucher (url, archivo) {
      this.voucherURL = url
      this.registro.voucher = encodeURIComponent(url)
      this.voucherArchivo = archivo
    },
    mostrarVoucher (archivo) {
      if (archivo !== null) {
        return decodeURIComponent(archivo)
      }
      return ''
    },
    rotar () {
      if (this.voucherVerClase === '') {
        this.voucherVerClase = 'rotate90'
      } else if (this.voucherVerClase === 'rotate90') {
        this.voucherVerClase = 'rotate180'
      } else if (this.voucherVerClase === 'rotate180') {
        this.voucherVerClase = 'rotate270'
      } else {
        this.voucherVerClase = ''
      }
      this.$forceUpdate()
    },
    onSubirVoucher (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          var img = document.createElement('img')
          img.src = fr.result
          img.addEventListener('load', () => {
            var canvas = document.createElement('canvas')
            var ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0)

            var MAX_WIDTH = 400
            var MAX_HEIGHT = 400
            var width = img.width
            var height = img.height

            if (width > height) {
              if (width > MAX_WIDTH) {
                height *= MAX_WIDTH / width
                width = MAX_WIDTH
              }
            } else {
              if (height > MAX_HEIGHT) {
                width *= MAX_HEIGHT / height
                height = MAX_HEIGHT
              }
            }
            canvas.width = width
            canvas.height = height
            ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, width, height)

            this.registrarVoucher(canvas.toDataURL(files[0].type), files[0])
          })
        })
      } else {
        this.voucherArchivo = ''
        this.voucherURL = ''
      }
    }
  }
}
</script>

<style>
.rotate90 {
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
}
.rotate180 {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
}
.rotate270 {
    -webkit-transform: rotate(270deg);
    -moz-transform: rotate(270deg);
    -o-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
}
</style>



// WEBPACK FOOTER //
// src/components/Pagos.vue